import { FaFacebookF, FaLinkedinIn, FaTwitter, FaMeetup, FaGithub } from 'react-icons/fa';
import { BsLinkedin, BsInstagram, BsGlobe, BsYoutube, BsFacebook } from 'react-icons/bs';
import { TfiYoutube } from 'react-icons/tfi';

export const CardHomeData = [
    {
        title: "card_1_title",
        img: "/photos/meetup-1.jpg",
        text: "card_1_text",
    },
    {
        title: "card_2_title",
        img: "/photos/meetup-2.jpg",
        text: "card_2_text",
    },
    {
        title: "card_3_title",
        img: "/photos/meetup-3.jpg",
        text: "card_3_text",
    }
]

export const PartnersData = [
    {
        img: "/photos/companies/google.png",
        name: "google",
    },
    {
        img: "/photos/companies/pagarme.png",
        name: "pagarme",
    },
    {
        img: "/photos/companies/lambda3.jpg",
        name: "lambda3",
    },
    {
        img: "/photos/companies/loft.jpg",
        name: "loft",
    },
    {
        img: "/photos/companies/pravaler.png",
        name: "pravaler",
    },
    {
        img: "/photos/companies/caelum.png",
        name: "caelum",
    },
    {
        img: "/photos/companies/flash.png",
        name: "Flash Benefícios",
    }
];

export enum SkillsTagsEnum {
    ai = 'ai',
    blockchain = 'blockchain',
    cloud = 'cloud',
    front_end = 'front end',
    back_end = 'back end',
    devops = 'devops',
    other = 'other',
}

export const SkillsData = [
    {
        name: "API - ChatGPT",
        value: 90,
        img: '/photos/skills/chatgpt.png',
        tags: [
            SkillsTagsEnum.ai
        ],
    },
    {
        name: "API - WhatsApp",
        value: 90,
        img: '/photos/skills/whatsapp.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Nest.JS",
        value: 90,
        img: '/photos/skills/nestjs.svg',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Node.JS",
        value: 90,
        img: '/photos/skills/nodejs.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "MongoDB",
        value: 90,
        img: '/photos/skills/mongodb.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "React",
        value: 90,
        img: '/photos/skills/react.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "Redis",
        value: 60,
        img: '/photos/skills/redis.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "GraphQL",
        value: 30,
        img: '/photos/skills/graphql.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "PostgreSQL",
        value: 80,
        img: '/photos/skills/postgresql.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "MySQL",
        value: 80,
        img: '/photos/skills/mysql.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Angular",
        value: 90,
        img: '/photos/skills/angular.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "HTML",
        value: 90,
        img: '/photos/skills/html.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "CSS",
        value: 90,
        img: '/photos/skills/css.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "SASS",
        value: 90,
        img: '/photos/skills/scss.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "GIT",
        value: 90,
        img: '/photos/skills/git.png',
        tags: [
            SkillsTagsEnum.other
        ],
    },
    {
        name: "Linux",
        value: 90,
        img: '/photos/skills/linux.png',
        tags: [
            SkillsTagsEnum.other
        ],
    },
    {
        name: "Google Cloud",
        value: 90,
        img: '/photos/skills/google-cloud.png',
        tags: [
            SkillsTagsEnum.cloud
        ],
    },
    {
        name: "AWS",
        value: 50,
        img: '/photos/skills/aws.png',
        tags: [
            SkillsTagsEnum.cloud
        ],
    },
    {
        name: "Digital Ocean",
        value: 90,
        img: '/photos/skills/digital-ocean.png',
        tags: [
            SkillsTagsEnum.cloud
        ],
    },
    {
        name: "Heroku",
        value: 90,
        img: '/photos/skills/heroku.png',
        tags: [
            SkillsTagsEnum.cloud
        ],
    },
    {
        name: "Docker",
        value: 70,
        img: '/photos/skills/docker.png',
        tags: [
            SkillsTagsEnum.devops
        ],
    },
    {
        name: "RabbitMQ",
        value: 70,
        img: '/photos/skills/rabbitmq.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Binance Smart Chain",
        value: 70,
        img: '/photos/skills/binance-smart-chain.png',
        tags: [
            SkillsTagsEnum.blockchain
        ],
    },
    {
        name: "Typescript",
        value: 90,
        img: '/photos/skills/typescript.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "PHP",
        value: 90,
        img: '/photos/skills/php.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Wordpress",
        value: 90,
        img: '/photos/skills/wordpress.png',
        tags: [
            SkillsTagsEnum.other
        ],
    },
    {
        name: "Flutter",
        value: 40,
        img: '/photos/skills/flutter.png',
        tags: [
            SkillsTagsEnum.front_end
        ],
    },
    {
        name: "Java",
        value: 70,
        img: '/photos/skills/java.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
    {
        name: "Spring Boot",
        value: 50,
        img: '/photos/skills/spring-boot.png',
        tags: [
            SkillsTagsEnum.back_end
        ],
    },
]

export const SocialData = [
    {
        label: 'linkedin',
        icon: <FaLinkedinIn />,
        link: 'https://www.linkedin.com/in/velrino/'
    },
    {
        label: 'instagram',
        icon: <BsInstagram />,
        link: 'https://www.instagram.com/velrino/'
    },
    {
        label: 'youTube',
        icon: <TfiYoutube />,
        link: 'https://www.youtube.com/@velrino'
    },
    {
        label: 'twitter',
        icon: <FaTwitter />,
        link: 'https://twitter.com/velrino'
    },
    {
        label: 'github',
        icon: <FaGithub />,
        link: 'https://www.github.com/velrino'
    },
]

export const MenuData = [
    {
        label: 'menu.home',
        link: 'section_home',
    },
    {
        label: 'menu.about',
        link: 'section_about',
    },
    {
        label: 'menu.support_us',
        link: 'section_experiences',
    },
    {
        label: 'menu.team',
        link: 'section_skills',
    },
    {
        label: 'menu.social_network',
        link: 'section_social',
    }
]

export const ExpirenceData = [
    {
        "title": "GO.K",
        "height": 40,
        "job": "Tech Lead & Senior Software Engineer",
        'desc': `I have the privilege of work as a Tech Lead and Senior Software Engineer.

        On the technical front, I possess both autonomy and expertise in a range of technologies, including:
        
        Front-end:
        - React
        - Ant Design
        - TDD
        - Git
        
        Back-end:
        - Nest.js
        - TDD
        - MongoDB
        - RabbitMQ
        - Docker
        - Git
        
        Using these tools, I develop and optimize applications, ensuring their efficiency, scalability, and high performance.
        
        In addition, I take charge of leading the Individual Development Plan (IDP) for the team, fostering their professional growth and honing their skills.
        
        Continuously seeking fresh challenges and opportunities, I leverage my experience and technical knowledge to drive project success and foster team expansion.`,
        "period": "04/2023 - atual",
        "bgColor": "#000",
        "img": "/photos/companies/gok.jpg",
        "url": "https://www.itau.com.br/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - ?",
            "url": "https://www.itau.com.br/"
        }
    },
    {
        "title": "ITAU BBA",
        "height": 40,
        "job": "Tech Lead - Senior Software Engineer",
        "period": "11/2022 - 04/2023",
        "bgColor": "#fff",
        "img": "/photos/companies/itau-bba.jpg",
        "url": "https://www.itau.com.br/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - ?",
            "url": "https://www.itau.com.br/"
        },
        desc: `Itaú BBA is build a new Bankline for Legal Person.

        I'm currently responsible for the User Authentication and Permissions squad for this New Bankline.
        
        DevOps:
        - AWS EKS for Spring Boot deployment
        - AWS S3 for Angular deployment
        - AWS Gateway for API management and security
        - AWS CodePipeline for application deployment
        - AWS STS for managing tokens between applications
        - Charon to encrypt requests from Front-end to Back-end
        - Docker for containerization
        
        Back-end:
        - Hexagonal architecture
        - Auth0 & CIAM (Customer Identity and Access Management)
        - Java
        - Spring Boot version 2.6.8
        - Test-driven development (TDD) with 90% code coverage
        - Swagger for API documentation
        
        Front-End:
        - Angular 13
        - Accessibility considerations
        - Voxel (internal framework)
        - Test-driven development (TDD) with 90% code coverage
        
        Other:
        - Confluence for Squad documentation
        - Git for version control
        - Git flow for branch management
        - Scrum as the project management methodology`
    },
    {
        "title": "Trustly",
        "job": "FIC Engineer",
        "height": 50,
        "period": "06/2021 - 04/2022",
        "bgColor": "#000",
        "img": "/photos/companies/trustly.jpg",
        "url": "https://trustly.net/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - ?",
            "url": "https://www.trustly.net/"
        },
        desc: `Trustly is a leading payment gateway serving North America and Europe.

        As part of my role, I am responsible for integrating Trustly's payment gateway with banks in the United States. This integration involves utilizing both web scraping techniques and REST API communication.
        
        Back-end: 
        - Java programming language 
        - Git for version control
        - PostgreSQL for database management 
        - Docker for containerization 
        - IntelliJ as the integrated development environment (IDE)
        - AWS, Google Cloud, and Azure for rotating IPs for web scraping
        
        Methodology: 
        - Scrum with Jira as the project management tool.`
    },
    {
        "title": "Investelly",
        "job": "Co-Founder",
        "height": 50,
        "period": "01/2021 - 07/2021",
        "bgColor": "#000",
        "img": "/photos/companies/investelly.png",
        "url": "https://investelly.com/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - ?",
            "url": "https://investelly.com/"
        }
    },
    {
        "title": "ITAU UNIBANCO",
        "height": 40,
        "job": "Software Engineer",
        "period": "(06/2019 - 05/2021)",
        "bgColor": "#f5821f",
        "img": "/photos/companies/itau.png",
        "url": "https://www.itau.com.br/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - ?",
            "url": "https://www.itau.com.br/"
        }
    },
    {
        "title": "STHORM",
        "height": 50,
        "job": "Technology Consultant Senior",
        "bgColor": "#000",
        "period": "(03/2020 - ?)",
        "img": "/photos/companies/sthorm.jpeg",
        "url": "https://sthorm.io/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "06/2019 - 11/2020",
            "url": "https://sthorm.io/"
        }
    },
    {
        "title": "VELRINO",
        "height": 50,
        "job": "Freelancer",
        "period": "(02/2015 - ?)",
        "img": "/assets/imgs/velrino-black.png",
        "url": "#",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "02/2015 - ?",
            "url": "#"
        }
    },
    {
        "title": "ACCENTURE",
        "url": "https://www.accenture.com/",
        "job": "Software Engineer Pleno",
        "period": "(02/2018 - 05/2019)",
        "img": "/photos/companies/accenture.jpeg",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "",
            "url": ""
        }
    },
    {
        "title": "QUERO QUITAR",
        "height": 50,
        "job": "Software Engineer Pleno",
        "period": "(04/2016 - 01/2017)",
        "url": "https://www.queroquitar.com.br/",
        "text": "",
        "bgColor": "#f15922",
        "img": "/photos/companies/queroquitar.png",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "",
            "url": "https://www.queroquitar.com.br/"
        }
    },
    {
        "title": "INGRESSE",
        "period": "(12/2014 - 03/2015)",
        "bgColor": "#fff",
        "job": "Intern",
        "img": "/photos/companies/ingresse.png",
        "url": "https://www.ingresse.com/",
        "text": "",
        "list": {
            "show": false,
            "title": "example",
            "skills": []
        },
        "link": {
            "show": false,
            "label": "12/2014 - 03/2015",
            "url": "https://ingresse.com/"
        }
    }
]